class MultiProductSubmit extends HTMLElement {
  constructor() {
    super();
    this.show_difficulty = this.dataset.showDifficulty;
    this.loadFiles();
    this.init();
    this.lines = [];
    this.current_Make = [];
    this.current_Model = [];
    this.current_Year = [];
    this.current_Submodel = [];
    this.current_Services = [];
    this.current_setProduct = [];
    this.show_products = false;
    this.show_next_input = true;
  }
  
  init(){
    const make = document.querySelectorAll('#make');
    make.forEach((element) => {
      element.addEventListener('change', (event) => {
        event.preventDefault();
        var make_value = event.target.value
        this.setModel(make_value);
      });
    });
    
    const model = document.querySelectorAll('#model');
    model.forEach((element) => {
      element.addEventListener('change', (event) => {
        event.preventDefault();
        var model_value = event.target.value
        this.setYear(model_value);
      });
    });

    const year = document.querySelectorAll('#year');
    year.forEach((element) => {
      element.addEventListener('change', (event) => {
        event.preventDefault();
        var year_value = event.target.value
        this.setSubmodel(year_value);
      });
    });

    const submodel = document.querySelectorAll('#sub-model');
    submodel.forEach((element) => {
      element.addEventListener('change', (event) => {
        event.preventDefault();
        var submodel_value = event.target.value;
        this.setServices(submodel_value);
      });
    });

    const services = document.querySelectorAll('#services');
    services.forEach((element) => {
      element.addEventListener('change', (event) => {
        event.preventDefault();
        var services_value = event.target.value
        this.setProduct(services_value);
      });
    });
  }

 loadFiles() {
  const file1 = $.ajax({ type: "GET", url: csv1, dataType: "text" });
  let file2 = Promise.resolve('');

  if (csv2 && csv2.trim() !== '') {
    file2 = $.ajax({ type: "GET", url: csv2, dataType: "text" });
  }

  Promise.all([file1, file2]).then(function([data1, data2]) {
    const lines = [];

    // Process first file lines
    const lines1 = data1.split(/\r\n|\n/);
    for (let i = 0; i < lines1.length; i++) {
      const line = lines1[i].trim();
      if (line) lines.push(line);
    }

    // Process second file if present
    if (data2.trim() !== '') {
      const lines2 = data2.split(/\r\n|\n/);
      console.log(lines2)
      for (let i = 1; i < lines2.length; i++) { // skip header
        const line = lines2[i].trim();
        if (line) lines.push(line);
      }
    }
    
    console.log(lines)
    // Instead of joining again into a big string, send lines directly
    this.ProcessData(lines);
  }.bind(this));
}

  ProcessData(allTextLines){
    this.lines = [];
    for (var j=1; j<allTextLines.length; j++) {
      if(allTextLines[j] == ''){
      }else{
        this.lines.push(allTextLines[j].split(','));
      }
    }

    var lines_item = []
    for (var j=0; j<this.lines.length; j++) {
      if(j == 0){
        document.querySelector('#make').insertAdjacentHTML('beforeend', "<option value='"+this.lines[j][0]+"'>"+this.lines[j][0]+"</option>");
        lines_item.push(this.lines[j][0]);
      }else{
        if(!lines_item.includes(this.lines[j][0])){
          document.querySelector('#make').insertAdjacentHTML('beforeend', "<option value='"+this.lines[j][0]+"'>"+this.lines[j][0]+"</option>");
          lines_item.push(this.lines[j][0]);
        }
      }
    }
    document.querySelector('.make').classList.remove('hide');
  }

  setModel(make_value){
    this.current_Model = [];

    var current_Models = []
    this.lines.filter(function(line){
      if(line[0] == make_value){
        current_Models.push(line);
      }   
    });
    this.current_Model = current_Models;
    this.current_Model.sort((a, b) => a[1].localeCompare(b[1]));

    document.querySelector('#model').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#year').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#sub-model').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#services').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('filter-items').innerHTML = "";

    document.querySelector('.sub-model').classList.remove('hide');
    document.querySelector('.services').classList.remove('hide');

    var Model_item = []
    for (var j=0; j<this.current_Model.length; j++) {
      if(j == 0){
        document.querySelector('#model').insertAdjacentHTML('beforeend', "<option value='"+this.current_Model[j][1]+"'>"+this.current_Model[j][1]+"</option>");
        Model_item.push(this.current_Model[j][1]);
      }else{
        if(!Model_item.includes(this.current_Model[j][1])){
          document.querySelector('#model').insertAdjacentHTML('beforeend', "<option value='"+this.current_Model[j][1]+"'>"+this.current_Model[j][1]+"</option>");
            Model_item.push(this.current_Model[j][1]);
        }
      }
    }

    document.querySelector('.model').classList.remove('hide');
  }

  setYear(model_value){
    this.current_Year = [];

    var current_Years = []
    this.current_Model.filter(function(line){
      if(line[1] == model_value){
        current_Years.push(line);
      }   
    });
    this.current_Year = current_Years;
    this.current_Year.sort((a, b) => a[2].localeCompare(b[2]));

    document.querySelector('#year').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#sub-model').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#services').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('filter-items').innerHTML = "";

    document.querySelector('.sub-model').classList.remove('hide');
    document.querySelector('.services').classList.remove('hide');

    var Type_item = []
    for (var j=0; j<this.current_Year.length; j++) {
      if(j == 0){
        document.querySelector('#year').insertAdjacentHTML('beforeend', "<option value='"+this.current_Year[j][2]+"'>"+this.current_Year[j][2]+"</option>");
        Type_item.push(this.current_Year[j][2]);
      }else{
        if(!Type_item.includes(this.current_Year[j][2])){
          document.querySelector('#year').insertAdjacentHTML('beforeend', "<option value='"+this.current_Year[j][2]+"'>"+this.current_Year[j][2]+"</option>");
          Type_item.push(this.current_Year[j][2]);
        }
      }
    }

    document.querySelector('.year').classList.remove('hide');
  }

  setSubmodel(year_value){
    this.current_Submodel = [];

    var current_Submodels = [];
    this.current_Year.filter(function(line){
      if(line[2] == year_value){
        current_Submodels.push(line);
      }   
    });
    this.current_Submodel = current_Submodels;
    this.current_Submodel.sort((a, b) => a[3].localeCompare(b[3]));

    this.show_products = false;
    this.show_next_input = false;
    for (let i = 0; i < this.current_Submodel.length; i++) {
      if(this.current_Submodel[i][3] == ''){
        this.show_products = true;
      }else{
        this.show_next_input = true
      }
    }
    document.querySelector('#sub-model').innerHTML = "<option disabled selected value=''>Select</option>";
    document.querySelector('#services').innerHTML = "<option disabled selected value=''>Select</option>";

    if(this.show_products){
      this.renderproducts(this.current_Submodel)
    }
    if(!this.show_next_input){
      document.querySelector('.sub-model').classList.add('hide');
      document.querySelector('.services').classList.add('hide');
    }else{
      document.querySelector('filter-items').innerHTML = "";
      document.querySelector('.services').classList.remove('hide');

      var submodel_item = [];
      var submodel_item_count = 0;
      for (var j=0; j<this.current_Submodel.length; j++) {
        if(this.current_Submodel[j][3] != ''){
          if(submodel_item_count == 0){
            
            document.querySelector('#sub-model').insertAdjacentHTML('beforeend', "<option value='"+this.current_Submodel[j][3]+"'>"+this.current_Submodel[j][3]+"</option>");
            submodel_item.push(this.current_Submodel[j][3]);
            submodel_item_count++
          }else{
            if(!submodel_item.includes(this.current_Submodel[j][3])){
              document.querySelector('#sub-model').insertAdjacentHTML('beforeend', "<option value='"+this.current_Submodel[j][3]+"'>"+this.current_Submodel[j][3]+"</option>");
              submodel_item.push(this.current_Submodel[j][3]);
              submodel_item_count++
            }
          }
        }
      }
  
      document.querySelector('.sub-model').classList.remove('hide');
    }
  }

  setServices(submodel_value){
    this.current_Services = [];

    var current_Servicess = []
    this.current_Submodel.filter(function(line){
      if(line[3] == submodel_value){
        current_Servicess.push(line);
      }   
    });
    this.current_Services = current_Servicess;
    this.current_Services.sort((a, b) => a[4].localeCompare(b[4]));

    this.show_products = false;
    this.show_next_input = false;
    for (let i = 0; i < this.current_Services.length; i++) {
      if(this.current_Services[i][4] == ''){
        this.show_products = true;
      }else{
        this.show_next_input = true
      }
    }
    document.querySelector('#services').innerHTML = "<option disabled selected value=''>Select</option>";

    if(this.show_products){
      this.renderproducts(this.current_Services)
    }
    if(!this.show_next_input){
      document.querySelector('.services').classList.add('hide');
    }else{
      var submodel_item = []
      for (var j=0; j<this.current_Services.length; j++) {
        if(j == 0){
          document.querySelector('#services').insertAdjacentHTML('beforeend', "<option value='"+this.current_Services[j][4]+"'>"+this.current_Services[j][4]+"</option>");
          submodel_item.push(this.current_Services[j][4]);
        }else{
          if(!submodel_item.includes(this.current_Services[j][4])){
            document.querySelector('#services').insertAdjacentHTML('beforeend', "<option value='"+this.current_Services[j][4]+"'>"+this.current_Services[j][4]+"</option>");
            submodel_item.push(this.current_Services[j][4]);
          }
        }
      }
  
      document.querySelector('.services').classList.remove('hide');
    }
  }

  setProduct(services_value){
    this.current_setProduct = [];

    var current_setProduct = [];
    this.current_Services.filter(function(line){
      if(line[4] == services_value){
        current_setProduct.push(line);
      }   
    });
    
    this.current_setProduct = current_setProduct;
    this.renderproducts(this.current_setProduct)
  }
  
renderproducts(products){
    var handles = '';
    for (let i = 0; i < products.length; i++) {
      var handle = products[i][5];
      if(i == 0){
        handles += handle;
      }else if(!handles.includes(handle)){
        handles += ','+handle;
      }
    }
    document.querySelector('filter-items').innerHTML = "";
    
    if(handles && handles !== "undefined"){
      const productHandles = handles.split(',');
      let productHTML = '';
      let completedRequests = 0;
      let universalTailKit = '';

      productHandles.forEach(handle => {
        fetch(`/products/${handle}?view=metafields`)
          .then(response => {
              if (!response.ok) {
                throw new Error(`Product not found: ${handle}`);
              }
              return response.json();
            })
          .then(data => {
            const product = data.product;
            if (!product || !product.variants) return; // Safety check
            
            const metafields = data.metafields;
            const isPPFProduct = product.tags.includes("PPF_product");

            const filledStar = `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.227 7.91761C16.227 9.33369 15.8783 10.6397 15.1809 11.8356C14.4835 13.0314 13.5372 13.9783 12.3422 14.6762C11.1471 15.3741 9.84206 15.723 8.42695 15.723C7.01185 15.723 5.70677 15.3741 4.51172 14.6762C3.31667 13.9783 2.37044 13.0314 1.67305 11.8356C0.975651 10.6397 0.626953 9.33369 0.626953 7.91761C0.626953 6.50152 0.975651 5.19553 1.67305 3.99965C2.37044 2.80377 3.31667 1.85689 4.51172 1.15901C5.70677 0.46113 7.01185 0.11219 8.42695 0.11219C9.84206 0.11219 11.1471 0.46113 12.3422 1.15901C13.5372 1.85689 14.4835 2.80377 15.1809 3.99965C15.8783 5.19553 16.227 6.50152 16.227 7.91761Z" fill="#F5AF05"/></svg>`;
            const unfilledStar = `<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_56_4937)"><path d="M8.22578 4.38877C7.2237 4.38877 6.29948 4.63608 5.45312 5.13069C4.60677 5.6253 3.93646 6.29608 3.44219 7.14302C2.94792 7.98997 2.70078 8.91483 2.70078 9.91761C2.70078 10.9204 2.94792 11.8452 3.44219 12.6922C3.93646 13.5391 4.60677 14.2099 5.45312 14.7045C6.29948 15.1991 7.2237 15.4464 8.22578 15.4464C9.22786 15.4464 10.1521 15.1991 10.9984 14.7045C11.8448 14.2099 12.5151 13.5391 13.0094 12.6922C13.5036 11.8452 13.7508 10.9204 13.7508 9.91761C13.7508 8.91483 13.5036 7.98997 13.0094 7.14302C12.5151 6.29608 11.8448 5.6253 10.9984 5.13069C10.1521 4.63608 9.22786 4.38877 8.22578 4.38877ZM16.0258 9.91761C16.0258 11.3337 15.6771 12.6397 14.9797 13.8356C14.2823 15.0314 13.3361 15.9783 12.141 16.6762C10.946 17.3741 9.64089 17.723 8.22578 17.723C6.81068 17.723 5.5056 17.3741 4.31055 16.6762C3.11549 15.9783 2.16927 15.0314 1.47187 13.8356C0.774479 12.6397 0.425781 11.3337 0.425781 9.91761C0.425781 8.50152 0.774479 7.19553 1.47187 5.99965C2.16927 4.80377 3.11549 3.85689 4.31055 3.15901C5.5056 2.46113 6.81068 2.11219 8.22578 2.11219C9.64089 2.11219 10.946 2.46113 12.141 3.15901C13.3361 3.85689 14.2823 4.80377 14.9797 5.99965C15.6771 7.19553 16.0258 8.50152 16.0258 9.91761Z" fill="#F5AF05"/></g><defs><clipPath id="clip0_56_4937"><rect width="15.6" height="18.733" fill="white" transform="matrix(1 0 0 -1 0.425781 19.2841)"/></clipPath></defs></svg>`;
            
            const initialVariant = product.variants.find(v => v.available) || product.variants[0];
            const countryCode = document.querySelector('[name="country_code"]').value;
            const formattedPrice = formatCurrency(initialVariant.price / 100, countryCode);

            let swatchesHTML = '';
            let ctaButtonHTML = '';
            let productDataScript = '';

            if (isPPFProduct) {
                if (product.variants.length === 2 && product.options[0].name !== 'Title') {
                    const option = product.options[0];
                    swatchesHTML += `<div class="product-option-group">
                                       <div class="swatches-container">`;
                    product.variants.forEach(variant => {
                        const value = variant.option1;
                        const isSelected = variant.id === initialVariant.id;
                        const isAvailable = variant.available;
                        const swatchId = `swatch-${variant.id}`;
                        swatchesHTML += `
                            <div class="swatch-element">
                                <input type="radio" id="${swatchId}" name="option-${product.id}-${option.name}" value="${value}" ${isSelected ? 'checked' : ''} ${!isAvailable ? 'disabled' : ''} onchange="onSwatchChange(this, ${product.id})">
                                <label for="${swatchId}" class="swatch-label ${!isAvailable ? 'sold-out' : ''}">${value}</label>
                            </div>
                        `;
                    });
                    swatchesHTML += `</div></div>`;
                }

                // Create the "Add To Cart" button
                const buttonText = initialVariant.available ? "Add To Cart" : "Sold Out";
                const buttonDisabled = !initialVariant.available ? 'disabled' : '';
                ctaButtonHTML = `
                    <a href="#" id="product-add-to-cart-${product.id}" onclick="addToCart(${initialVariant.id}, this)" class="button button--full-width button--primary ${buttonDisabled ? 'disabled' : ''}" ${buttonDisabled} data-variant-id="${initialVariant.id}">
                        <span>${buttonText}</span>
                    </a>
                `;

                // Include the product data for the onSwatchChange function
                productDataScript = `<script type="application/json" id="product-data-${product.id}">${JSON.stringify(product)}</script>`;

            } else {
                // Swatches remain empty: swatchesHTML = '';
                // Create the "Choose Options" button
                ctaButtonHTML = `
                    <a href="/products/${product.handle}" class="button button--full-width button--primary" aria-haspopup="dialog">
                        <span>Choose Options</span>
                    </a>
                `;
                // Product data script remains empty: productDataScript = '';
            }

            const dataItem = `
              <div class="facets-items-collection-view-row product-card-wrapper" data-product-id="${product.id}">
                <div class="facets-items-collection-view-cell-span12">
                  <div class="search-coverage-item">
                    <div class="search-coverage-item-image">
                      <a href="/products/${product.handle}">
                        <img id="product-image-${product.id}" src="${initialVariant.featured_image ? initialVariant.featured_image.src : product.featured_image}" alt="${product.title}" />
                      </a>
                    </div>
                    <div class="multi-pro-info-inner-col">
                      <div class="multi-pro-info-inner-col-left">
                        <a href="/products/${product.handle}"> ${product.title} </a>
                        ${swatchesHTML}
                        <div class="product-sku-info">Includes installation kit</div>
                        ${this.show_difficulty === "true" && metafields.difficulty !== '' ? `
                          <div class="multi-pro-info-inner-col-left-rating">
                            Difficulty Rating:
                            <div class="star-item-body">
                              ${Array.from({ length: 5 }, (_, i) => i < Number(metafields.difficulty) ? `<span>${filledStar}</span>` : `<span>${unfilledStar}</span>`).join('')}
                            </div>
                          </div>
                        ` : ''}
                        ${this.show_difficulty === "true" && metafields.difficulty > 3 ? `<p>Professional Installation strongly recommended</p>` : ''}
                      </div>
                      <div class="multi-pro-info-inner-col-right">
                        <a href="#" class="multi-pro-info-inner-col-free-ship-info"> Free Shipping </a>
                        <div class="inner-col-right-price-info">
                          <span id="product-price-${product.id}" class="inner-col-right-price-info-original money">
                            ${formattedPrice}
                          </span>
                        </div>
                        ${ctaButtonHTML}
                      </div>
                    </div>
                  </div>
                </div>
                ${productDataScript}
              </div>
            `;
            if( handle != "universal-tail-light-kit" ){
              productHTML += dataItem;
            } else {
              universalTailKit = dataItem;
            }
          })
          .catch(error => {
            console.error('Error fetching product:', error);
          })
          .finally(() => {
            completedRequests++;
            if (completedRequests === productHandles.length) {
              this.appendProductsToHTML(productHTML + universalTailKit);
            }
          });
      });
    }
}
  appendProductsToHTML(productHTML) {
    const productContainer = document.querySelector('filter-items');
    productContainer.innerHTML = productHTML; // Append the generated HTML to the container
  }
}

/**
 * Updates a product card when a variant swatch is selected.
 * This version is simplified for products with a single option type.
 * @param {HTMLElement} swatchElement - The radio button swatch that was changed.
 * @param {number} productId - The Shopify ID of the product.
 */
function onSwatchChange(swatchElement, productId) {
  const productCard = document.querySelector(`.product-card-wrapper[data-product-id="${productId}"]`);
  if (!productCard) return;

  // 1. Get the selected option value (e.g., "Gloss" or "Matte")
  const selectedValue = swatchElement.value;

  // 2. Find the matching variant from the embedded JSON data
  const dataScript = document.getElementById(`product-data-${productId}`);
  if (!dataScript) return;
  
  const productData = JSON.parse(dataScript.textContent);
  
  // Find the variant where its first option matches the selected value
  const matchedVariant = productData.variants.find(variant => variant.option1 === selectedValue);

  if (matchedVariant) {
    // 3. Update the card elements
    // Update Price
    const priceElement = productCard.querySelector(`#product-price-${productId}`);
    const countryCode = document.querySelector('[name="country_code"]').value; 
    priceElement.innerHTML = formatCurrency(matchedVariant.price / 100, countryCode);

    // Update Image
    const imageElement = productCard.querySelector(`#product-image-${productId}`);
    if (matchedVariant.featured_image) {
      imageElement.src = matchedVariant.featured_image.src;
      imageElement.alt = matchedVariant.featured_image.alt;
    } else if (productData.featured_image) {
      imageElement.src = productData.featured_image; // Fallback to main product image
    }

    // Update the "Add to Cart" button
    const ctaButton = productCard.querySelector(`#product-add-to-cart-${productId}`);
    ctaButton.setAttribute('onclick', `addToCart(${matchedVariant.id}, this)`);
    ctaButton.setAttribute('data-variant-id', matchedVariant.id);
    
    // The button state (enabled/disabled) is handled by the initial render and CSS
    // so no changes are needed here unless you want to re-check availability.
    // For simplicity, we assume availability doesn't change after load.
  }
}
customElements.define('multi-product-submit', MultiProductSubmit);

function refreshCartDrawer() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartContent = doc.querySelector('#CartDrawer');

            if (newCartContent) {
                document.querySelector('#CartDrawer').innerHTML = newCartContent.innerHTML;
            }
            // Open the cart drawer after updating
            const cartDrawer = document.querySelector('cart-drawer');
            cartDrawer.classList.remove("is-empty")
            cartDrawer.open();
        });
    })
      .catch(error => console.error('Error refreshing cart:', error));
  }

function addToCart(productId, button) {
    event.preventDefault(); // Prevent redirection

    let span = button.querySelector('span');

    if (button.classList.contains('disabled')) return; // Prevent multiple clicks

    button.classList.add('disabled'); // Add class to disable clicks
    span.textContent = 'Adding...'; // Change text

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
        console.log(data)
        refreshCartDrawer();
    })
    .catch(error => console.error('Error:', error));

    // Restore button state after 2 seconds
    setTimeout(() => {
        button.classList.remove('disabled');
        span.textContent = 'Add to Cart';
    }, 2000);
}


function formatCurrency(price, countryCode) {
  const currencyMap = {
    "AF": "AFN",  "AL": "ALL",  "DZ": "DZD",  "AS": "USD",  "AD": "EUR",  "AO": "AOA", 
    "AI": "XCD",  "AG": "XCD",  "AR": "ARS",  "AM": "AMD",  "AW": "AWG",  "AU": "AUD", 
    "AT": "EUR",  "AZ": "AZN",  "BS": "BSD",  "BH": "BHD",  "BD": "BDT",  "BB": "BBD", 
    "BY": "BYN",  "BE": "EUR",  "BZ": "BZD",  "BJ": "XOF",  "BM": "BMD",  "BT": "BTN", 
    "BO": "BOB",  "BA": "BAM",  "BW": "BWP",  "BR": "BRL",  "IO": "USD",  "VG": "USD", 
    "BN": "BND",  "BG": "BGN",  "BF": "XOF",  "BI": "BIF",  "KH": "KHR",  "CM": "CMF", 
    "CA": "CAD",  "CV": "CVE",  "KY": "KYD",  "CF": "XOF",  "TD": "CDF",  "CL": "CLP", 
    "CN": "CNY",  "CX": "AUD",  "CC": "AUD",  "CO": "COP",  "KM": "KMF",  "CG": "CDF", 
    "CD": "CDF",  "CK": "NZD",  "CR": "CRC",  "HR": "HRK",  "CU": "CUP",  "CW": "ANG", 
    "CY": "CYP",  "CZ": "CZK",  "DK": "DKK",  "DJ": "DJF",  "DM": "XCD",  "DO": "DOP", 
    "EC": "USD",  "EG": "EGP",  "SV": "SVC",  "GQ": "GNF",  "ER": "ERN",  "EE": "EEK", 
    "ET": "ETB",  "FK": "FKP",  "FO": "DKK",  "FJ": "FJD",  "FI": "EUR",  "FR": "EUR", 
    "GF": "EUR",  "PF": "XPF",  "TF": "XPF",  "GA": "GHS",  "GM": "GMD",  "GE": "GEL", 
    "DE": "EUR",  "GH": "GHS",  "GI": "GIP",  "GR": "GRD",  "GL": "DKK",  "GD": "XCD", 
    "GP": "EUR",  "GU": "USD",  "GT": "GTQ",  "GG": "GBP",  "GN": "GNF",  "GW": "GNF", 
    "GY": "GYD",  "HT": "HTG",  "HM": "AUD",  "HN": "HNL",  "HK": "HKD",  "HU": "HUF", 
    "IS": "ISK",  "IN": "INR",  "ID": "IDR",  "IR": "IRR",  "IQ": "IQD",  "IE": "EUR", 
    "IL": "ILS",  "IT": "EUR",  "JM": "JMD",  "JP": "JPY",  "JE": "GBP",  "JO": "JOD", 
    "KZ": "KZT",  "KE": "KES",  "KI": "AUD",  "KP": "KPW",  "KR": "KRW",  "KW": "KWD", 
    "KG": "KGS",  "LA": "LAK",  "LV": "LVL",  "LB": "LBP",  "LS": "LSL",  "LR": "LRD", 
    "LY": "LYD",  "LI": "CHF",  "LT": "LTL",  "LU": "EUR",  "MO": "MOP",  "MK": "MKD", 
    "MG": "MGA",  "MW": "MWK",  "MY": "MYR",  "MV": "MVR",  "ML": "CFA",  "MT": "EUR", 
    "MH": "USD",  "MQ": "EUR",  "MR": "MRO",  "MU": "MUR",  "YT": "EUR",  "MX": "MXN", 
    "FM": "USD",  "MD": "MDL",  "MC": "EUR",  "MN": "MNT",  "ME": "EUR",  "MS": "USD", 
    "MA": "MAD",  "MZ": "MZN",  "MM": "MMK",  "NA": "NAD",  "NR": "AUD",  "NP": "NPR", 
    "NL": "EUR",  "NC": "XPF",  "NZ": "NZD",  "NI": "NIO",  "NE": "GNF",  "NG": "NGN", 
    "NU": "NZD",  "NF": "AUD",  "MP": "USD",  "NO": "NOK",  "OM": "OMR",  "PK": "PKR", 
    "PW": "USD",  "PS": "ILS",  "PA": "PAB",  "PG": "PGK",  "PY": "PYG",  "PE": "PEN", 
    "PH": "PHP",  "PN": "NZD",  "PL": "PLN",  "PT": "EUR",  "PR": "USD",  "QA": "QAR", 
    "RE": "EUR",  "RO": "RON",  "RU": "RUB",  "RW": "RWF",  "SH": "SHP",  "KN": "XCD", 
    "LC": "XCD",  "PM": "EUR",  "VC": "XCD",  "WS": "WST",  "SM": "EUR",  "ST": "STN", 
    "SA": "SAR",  "SN": "CFA",  "RS": "RSD",  "SC": "SCR",  "SL": "SLL",  "SG": "SGD", 
    "SX": "ANG",  "SK": "SKK",  "SI": "SIT",  "SB": "SBD",  "SO": "SOS",  "ZA": "ZAR", 
    "GS": "GBP",  "ES": "EUR",  "LK": "LKR",  "SD": "SDG",  "SR": "SRD",  "SS": "SSP", 
    "SJ": "NOK",  "SE": "SEK",  "CH": "CHF",  "SY": "SYP",  "TW": "TWD",  "TJ": "TJS", 
    "TZ": "TZS",  "TH": "THB",  "TL": "USD",  "TG": "TGN",  "TK": "NZD",  "TO": "TOP", 
    "TT": "TTD",  "TN": "TND",  "TR": "TRY",  "TM": "TMT",  "TC": "USD",  "TV": "AUD", 
    "UG": "UGX",  "UA": "UAH",  "AE": "AED",  "GB": "GBP",  "US": "USD",  "UY": "UYU", 
    "UZ": "UZS",  "VU": "VUV",  "VE": "VES",  "VN": "VND",  "WF": "XPF",  "EH": "MAD", 
    "YE": "YER",  "ZM": "ZMW",  "ZW": "ZWL"
  };

  const currency = currencyMap[countryCode] || 'USD';  // Default to USD if country code is not in the map
  const formattedPrice = price.toLocaleString();

  // Use a switch statement to handle different currencies
  switch (currency) {
    case 'PKR':
      return `Rs.${formattedPrice} ${currency}`;
    case 'USD':
      return `$${formattedPrice} ${currency}`;
    case 'EUR':
      return `€${formattedPrice} ${currency}`;
    case 'INR':
      return `₹${formattedPrice} ${currency}`;
    case 'AUD':
      return `A${formattedPrice} ${currency}`;
    case 'CAD':
      return `CA$${formattedPrice} ${currency}`;
    case 'GBP':
      return `£${formattedPrice} ${currency}`;
    case 'BRL':
      return `R$${formattedPrice} ${currency}`;
    case 'CNY':
      return `¥${formattedPrice} ${currency}`;
    case 'JPY':
      return `¥${formattedPrice} ${currency}`;
    case 'SAR':
      return `SR${formattedPrice} ${currency}`;
    case 'CHF':
      return `CHF ${formattedPrice} ${currency}`;
    // Add more cases as needed for other currencies...
    default:
      return `${formattedPrice} ${currency}`;
  }
}